import React from 'react';
import JsonPreview from '../common/JsonPreview';

const ExplainPanel = ({ data, loading, error }) => {
  if (error) return <div className="text-destructive text-sm">{String(error)}</div>;
  if (loading) return <div className="text-sm text-textSecondary">Loading…</div>;
  if (!data) return <div className="text-sm text-textSecondary">No data.</div>;

  const { summary, path, state, bar_index, symbol, timeframe } = data || {};

  const sections = Object.keys(path || {});

  return (
    <div className="space-y-3">
      <div className="rounded-md border border-borderDefault p-2 text-sm">
        <div className="flex flex-wrap items-center gap-3">
          <div><strong>Bar:</strong> {bar_index ?? '—'}</div>
          <div><strong>Symbol:</strong> {symbol ?? '—'}</div>
          <div><strong>Timeframe:</strong> {timeframe ?? '—'}</div>
          <div className="ml-auto"><strong>Action:</strong> {summary?.action ?? '—'} | <strong>Reason:</strong> {summary?.reason ?? '—'}</div>
        </div>
      </div>

      {/* Path */}
      <div className="rounded-md border border-borderDefault">
        <div className="p-2 font-medium text-sm">Path</div>
        <div className="divide-y divide-borderDefault">
          {sections.length === 0 && <div className="p-2 text-xs text-textSecondary">No path entries.</div>}
          {sections.map((sec) => (
            <div key={sec} className="p-2">
              <div className="mb-1 text-xs uppercase text-textSecondary">{sec}</div>
              {(path[sec] || []).map((atom, i) => (
                <div key={i} className="mb-2">
                  <div className="text-xs mb-1"><span className="px-2 py-0.5 rounded bg-muted text-textSecondary">{atom.kind}</span></div>
                  <JsonPreview data={atom.payload} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* State */}
      <div>
        <div className="font-medium text-sm mb-1">State</div>
        <JsonPreview data={state} />
      </div>
    </div>
  );
};

export default ExplainPanel;
